import React from 'react'
import { Link } from '@morningtrain/react-navigation'
import { Translation } from '@morningtrain/react-translations'
import useDepartmentId from 'support/hooks/use-department-id'
import Button from 'ui/buttons/Button'
import useSelectedDepartmentIds from 'support/hooks/use-selected-department-ids'
import * as Icons from 'ui/icons'
import { VerticalList } from 'ui/layouts'
import { Can } from '@morningtrain/react-auth'
import {Env} from "@morningtrain/helpers";

export default function SalaryExports () {
  const [departmentId] = useDepartmentId()
  const [selectedDepartmentIds] = useSelectedDepartmentIds()
  const hasEmployeeBorrowing = Env.get('globals.has_department_employee_borrowing');

  return (
    <VerticalList border={false}>

      <Can permission='app.hr.salary.exports.csv_export'>
        <div className='flex justify-between items-center'>
          <span><Translation name='exports.csv_export' /></span>
          <Link newTab route='app.hr.salary.exports.csv_export' parameters={{ month: 'model:month', year: 'model:year', department_id: departmentId }}>
            <Button>
              <Icons.ArrowRight />
            </Button>
          </Link>
        </div>
      </Can>

      <Can permission='app.hr.salary.exports.csv_control_export'>
        <div className='flex justify-between items-center'>
          <span><Translation name='exports.csv_control_export' /></span>
          <Link newTab route='app.hr.salary.exports.csv_control_export' parameters={{ month: 'model:month', year: 'model:year', department_id: departmentId }}>
            <Button>
              <Icons.ArrowRight />
            </Button>
          </Link>
        </div>
      </Can>

      {hasEmployeeBorrowing ? <Can permission='app.hr.salary.exports.employee_lenting_export'>
        <div className='flex justify-between items-center'>
          <span><Translation name='exports.employee_lenting_export' /></span>
          <Link newTab route='app.hr.salary.exports.employee_lenting_export' parameters={{ month: 'model:month', year: 'model:year', department_ids: selectedDepartmentIds.join(',') }}>
            <Button>
              <Icons.ArrowRight />
            </Button>
          </Link>
        </div>
      </Can> : false}

      <Can permission='app.hr.salary.exports.csv_new_employees_export'>
        <div className='flex justify-between items-center'>
          <span><Translation name='exports.new_employees_export' /></span>
          <Link newTab route='app.hr.salary.exports.csv_new_employees_export' parameters={{ salary_period_id: 'model:id' }}>
            <Button>
              <Icons.ArrowRight />
            </Button>
          </Link>
        </div>
      </Can>

      <Can permission='app.hr.salary.exports.employees_with_changes_export'>
        <div className='flex justify-between items-center'>
          <span><Translation name='exports.employees_with_changes_export' /></span>
          <Link newTab route='app.hr.salary.exports.employees_with_changes_export' parameters={{ salary_period_id: 'model:id' }}>
            <Button>
              <Icons.ArrowRight />
            </Button>
          </Link>
        </div>
      </Can>

    </VerticalList>
  )
}
